import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const ReportOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function ReportOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fill="currentColor">
          <path d="M12.885 6.495h-2v6h2v-6ZM11.885 17.495a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" />
          <path d="m21.845 9.995-3.19-5.5a4.006 4.006 0 0 0-3.46-1.99h-6.39c-1.42 0-2.75.76-3.46 1.99l-3.19 5.5a3.992 3.992 0 0 0 0 4.01l3.19 5.5a4.006 4.006 0 0 0 3.46 1.99h6.39c1.42 0 2.75-.76 3.46-1.99l3.19-5.5c.72-1.24.72-2.77 0-4.01Zm-1.73 3-3.19 5.5c-.36.62-1.02 1-1.73 1h-6.39c-.71 0-1.38-.38-1.73-1l-3.19-5.5c-.36-.62-.36-1.39 0-2.01l3.19-5.5c.36-.62 1.02-1 1.73-1h6.39c.71 0 1.38.38 1.73 1l3.19 5.5c.36.62.36 1.39 0 2.01Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default ReportOutlined;